import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { toolbarHeight } from "./ApplicationBar";
import { NavLink, useRouteMatch } from "react-router-dom";
import ProfileMenu from "../../../Controllers/UserMenu";
import { useDispatch, useSelector } from "react-redux";
import { resetServiceFunction } from "../../../store/formSlice";
import { proposalSelector } from "../../../store/proposalSlice";
import { useMemo } from "react";

export const drawerWidth = 300;
const PRE_PROPOSAL_STATUS = 957290000;

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    whiteSpace: "nowrap",
    position: "relative",
    width: drawerWidth,
    marginTop: toolbarHeight,
    marginBottom: toolbarHeight,
    maxHeight: `calc(100vh - ${toolbarHeight * 2}px)`,

    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  navContainer: {
    paddingLeft: theme.spacing(2),
    maxHeight: `calc(100vh - ${toolbarHeight * 2 + 100}px)`,
    overflow: "auto",
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
  },
  navHeader: {
    fontWeight: 600,
    fontSize: 16,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  CloseNavHeader: {
    fontWeight: 900,
    fontSize: 20,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2.1),
    textAlign: "center",
    marginLeft: -6,
  },
  navItem: {
    minWidth: 40,
  },
  activeNav: {
    color: theme.palette.gif.blue.color,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(10),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(10) + 1,
    },
  },
  listItemText: {
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
}));

const IsActive = (route) => {
  const match = useRouteMatch(route);
  if (!match) return false;
  return true;
};

export default function NavigationDrawer(props) {
  const { navigation, open } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const proposal = useSelector(proposalSelector);
  const filterNavigation = useMemo(() => {
    if (!proposal) return;
    let newNav = navigation({ preProposal: proposal.status === PRE_PROPOSAL_STATUS });
    if (proposal.status === PRE_PROPOSAL_STATUS) {
      newNav.links = newNav.links.filter((nav) => nav.preProposal);
    }
    return newNav;
  }, [navigation, proposal]);

  return (
    <Drawer
      variant="permanent"
      className={`${open ? classes.drawerOpen : classes.drawerClose}`}
      classes={{
        paper: `${open ? classes.drawerOpen : classes.drawerClose} ${
          classes.drawerPaper
        }`,
      }}
    >
      <ProfileMenu open={open} />
      <Divider variant="middle" />
      {filterNavigation && (
        <Box component="nav" className={classes.navContainer}>
          <List key={filterNavigation.header}>
            {open ? (
              <div className={classes.navHeader}>{filterNavigation.header}</div>
            ) : (
              <div className={classes.CloseNavHeader}>
                {filterNavigation.header[0]}
              </div>
            )}
            {filterNavigation?.links?.map((l) => (
              <ListItem
                className={classes.listItem}
                key={l.text}
                button
                onClick={() => dispatch(resetServiceFunction())}
                alignItems="center"
                to={l.route}
                component={NavLink}
                activeClassName={classes.activeNav}
              >
                <ListItemIcon className={classes.navItem}>
                  {l.icon({
                    className: `${
                      IsActive(`${l.route}`) ? classes.activeNav : ""
                    }`,
                  })}
                </ListItemIcon>
                <ListItemText
                  className={classes.listItemText}
                  primary={l.text}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Drawer>
  );
}
